<script>
import {api} from "@/modules/api";
import SelectField from "@/components/input/SelectField.vue";
import AccordionComponents from "@/components/Accordion.vue";

export default {
  name: 'ShopFilters',
  components: {AccordionComponents, SelectField},
  data () {
    return {
      formData: {
        price: {}
      },
      options: {},
      viewFilters: false
    }
  },
  watch: {
    formData: {
      handler () {
        if (this.formData.price.min === this.options.price.value.min && this.formData.price.max === this.options.price.value.max && !this.formData.category) {
          return
        }
        this.emitter.emit('filter-shop', this.formData)
      },
      deep: true
    },
  },
  mounted () {
    this.loadOptions()
    this.emitter.on('drop-filter', (event) => {
      if (event !== 'price') {
        this.formData = Object.entries(this.formData)
            .filter(([key]) => key !== event)
            .reduce((acc, [key, value]) => {
              acc[key] = value
              return acc
            }, {})
      }
      this.emitter.emit('filter-shop', this.formData)
    })
    this.emitter.on('open-filter', () => {
      this.viewFilters = !this.viewFilters
    })
  },
  computed: {
    selectOptions () {
      if (this.options.categories) {
        return this.options.categories.value.map((option) => {
          return {
            value: option.id,
            text: option.Label
          }
        })
      }
      return {}
    }
  },
  methods: {
    async loadOptions () {
      api.products.options().then((response) => {
        this.options = response
        this.formData.price.min = this.options.price.value.min
        this.formData.price.max = this.options.price.value.max
      })
    }
  }
}
</script>

<template>
  <div class="p-4 lg:w-1/5 relative lg:sticky lg:mt-20">
    <h2 class="text-sm font-semibold text-gray-500 dark:text-gray-200">Filtres :</h2>
    <accordion-components title="Recherche">
        <div class="w-full">
          <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only">Search</label>
          <div class="relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
            </div>
            <input
                type="search"
                id="default-search"
                class="block w-full ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                placeholder="Rechercher produit..."
                required
                @input="emitter.emit('search', $event.target.value)"
            />
          </div>
        </div>
    </accordion-components>
    <accordion-components title="Catégorie">
      <select-field
          v-model="formData.category"
          :options="selectOptions"
      />
    </accordion-components>
    <accordion-components title="Prix">
      <div v-if="options.price" class="flex justify-between items-center my-5">
        <div class="my-5">
          <label for="steps-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            De {{ formData.price.min }} €
          </label>
          <input
              v-model="formData.price.min"
              id="steps-range"
              type="range"
              :min="options.price.value.min"
              :max="formData.price.max"
              step="5"
              class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          >
        </div>
        <div class="my-5">
          <label for="steps-range" class="block mb-2 text-sm font-medium text-gray-900">
            A {{ formData.price.max }} €
          </label>
          <input
              v-model="formData.price.max"
              id="steps-range"
              type="range"
              :min="formData.price.min"
              :max="options.price.value.max"
              step="5"
              class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-orange-100"
          >
        </div>
      </div>
    </accordion-components>
  </div>
</template>
